<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    import Mobilebtn2 from '../mobilebtn2.svelte';
    let img;
    let main;
    // let title;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {scale: 1, duration: 1},
                {scale: 1.5, duration: 1, x: 100, y: -200},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            head,
            [
                {scale: 1, marginLeft: '2.57vw', duration: 1},
                {scale: 1, duration: 1},
            ],
            3,
        );
    }
    let head;
</script>

<div class="main" bind:this={main}>
    <div class="main-img" bind:this={img}>
        <img
            src="images/featuersMobile/Main7.png"
            alt=""
            width="100%"
            height="100%"
        />
    </div>

    <div class="container">
        <div class="div1" bind:this={head}><p>PERFORMERS</p></div>
        <div class="div2">
            <p>
                Become part of history as we build the future in which you won't
                have to take multiple shots for a single performance, rather
                based on a myriad performance captures, your likeness will be
                digitized, owned and would be perpetually used into any
                production.
            </p>
        </div>
        <a href="/performance">
            <div class="div3">
                <Mobilebtn2
                popup = false
                bgcolor="transparent"
                text="Learn More"
                width="23.364vw"
                height="7.477vw"
                txtcolor="black"
                border="black"
                textPadding = '0vw'
            /></div>
        </a>
    </div>
</div>

<style>
    .div3 {
        position: absolute;
        margin-left: 65.888vw;
        top: 166.701vw;
    }

    .div2 {
        width: 78.505vw;
        height: 21.028vw;
        margin-top: 3.738vw;
        margin-left: 8.411vw;
    }
    .div2 p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.57vw;
        line-height: 140%;
        /* or 15px */

        letter-spacing: 0.06em;

        color: #000000;
    }
    .div1 {
        width: 79.673vw;
        height: 12.383vw;
        margin-left: 20.5vw;
        scale: 1.55;
        
    }
    .div1 p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 900;
        font-size: 9.813vw;
        line-height: 12.383vw;
        text-transform: uppercase;
        color: #000000;
    }
    .main {
        width: 100%;
        height: max(216.355vw, 100.16vh);
        position: relative;
        overflow: hidden;
    }
    .container {
        width: 100%;
        height: 100%;
        position: absolute;
        margin-top: 36.215vw;
    }
    .main-img {
        position: absolute;
        height: max(144.86vw, 66.955vw);
        width: 100%;
        bottom: 0;
        transform: scale(0.2);
    }
</style>
